/**
 * Seat layout for a shell (rowers + optional cox). Keep in sync with backend/utils/boatSeats.js.
 * @param {string} [boatClass]
 * @returns {{ seats: string[], hasCox: boolean, numRowers: number }}
 */
export function getSeatsForBoatClass(boatClass) {
  if (!boatClass) return { seats: [], hasCox: false, numRowers: 0 };
  const c = String(boatClass);
  if (c === 'Launch') {
    return { seats: [], hasCox: false, numRowers: 0 };
  }
  if (c === 'Erg' || c.startsWith('Erg')) {
    return { seats: ['Bow'], hasCox: false, numRowers: 1 };
  }

  const hasCox = c.endsWith('+') || c.includes('+/');
  let numRowers = 0;
  if (c.startsWith('8')) numRowers = 8;
  else if (c.startsWith('4')) numRowers = 4;
  else if (c.startsWith('2')) numRowers = 2;
  else if (c.startsWith('1')) numRowers = 1;
  else return { seats: [], hasCox: false, numRowers: 0 };

  const seats = [];
  if (numRowers === 1) {
    seats.push('Bow');
  } else {
    seats.push('Stroke');
    for (let i = numRowers - 1; i > 1; i--) {
      seats.push(String(i));
    }
    seats.push('Bow');
  }
  if (hasCox) seats.push('Cox');
  return { seats, hasCox, numRowers };
}

/**
 * Count of physical seats in a shell (rowers + optional cox). Keep in sync with backend/utils/boatSeats.js.
 * @param {string} [boatClass]
 * @returns {number}
 */
export function getSeatCountForBoatClass(boatClass) {
  const { seats } = getSeatsForBoatClass(boatClass);
  return seats.length > 0 ? seats.length : 8;
}
